// Registers web's synchronous (localStorage-backed) storage service into the
// shared DI container as a side effect.
//
// This MUST be imported before any shared persist store module is evaluated —
// the stores hydrate synchronously at module-eval time, so the sync service has
// to be registered first. main.tsx imports this immediately after
// `reflect-metadata` and before `App` (which transitively imports the stores).
//
// NOTE: import `registerSyncStorageService` from the deep di/container path, NOT
// the `@personal-trainer-app/shared` barrel — the barrel re-exports the stores,
// so importing from it here would evaluate (and hydrate) them before this
// registration runs, defeating the purpose.
import {
  registerSyncStorageService,
  registerAuthConfig,
} from '@personal-trainer-app/shared/src/di/container';

import { WebSyncStorageService } from '../services/storage.service';

registerSyncStorageService(WebSyncStorageService);

// Web is always SESSION auth (stateful cookie + CSRF). Register the platform
// auth config here — synchronously, before the stores hydrate and App renders —
// so getAuthMode() and the auth client transport are correct from the first
// render (no async pin race). Mode is a per-platform constant,
// not persisted state.
registerAuthConfig({
  mode: 'session',
  withCredentials: true,
  withXSRFToken: true,
});
